"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var SingleLineViewPreviewLine_1 = require("./SingleLineViewPreviewLine");
var SingleLineViewSubjectLine_1 = require("./SingleLineViewSubjectLine");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var SingleLineViewSecondColumn = /** @class */ (function (_super) {
    tslib_1.__extends(SingleLineViewSecondColumn, _super);
    function SingleLineViewSecondColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleLineViewSecondColumn.prototype.render = function () {
        return (React.createElement("div", { className: styles.secondColumn },
            React.createElement("div", { className: styles.content },
                React.createElement(SingleLineViewSubjectLine_1.default, { isUnread: this.props.isUnread, subjectTexts: this.props.subjectTexts, originalPriceTexts: this.props.originalPriceTexts, currentPriceTexts: this.props.currentPriceTexts }),
                React.createElement(SingleLineViewPreviewLine_1.default, { previewTexts: this.props.previewTexts }))));
    };
    SingleLineViewSecondColumn = tslib_1.__decorate([
        mobx_react_1.observer
    ], SingleLineViewSecondColumn);
    return SingleLineViewSecondColumn;
}(React.Component));
exports.default = SingleLineViewSecondColumn;
//# sourceMappingURL=SingleLineViewSecondColumn.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/SingleLineViewSecondColumn.js
// module id = 5999
// module chunks = 67